import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonInput,
  IonButton,
  IonItem,
  IonLabel,
  IonText,
  IonContent,
  IonLoading,
} from "@ionic/react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../redux/actions/forgotPasswordActions";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { status, message, error } = useSelector(
    (state) => state.forgotPassword
  );

  const handleSubmit = () => {
    if (!email) return;
    dispatch(forgotPassword(email));
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <IonToolbar>
            <IonTitle>Forgot Password</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          <IonItem>
            {/* <IonLabel position="floating">Email Address</IonLabel> */}
            <IonInput
              placeholder="Your Email"
              type="email"
              value={email}
              onIonChange={(e) => setEmail(e.detail.value)}
            />
          </IonItem>

          <IonButton
            expand="block"
            onClick={handleSubmit}
            className="ion-margin-top"
          >
            Send Reset Link
          </IonButton>

          <IonLoading isOpen={status === "loading"} message="Sending..." />
          {message && (
            <IonText color="success">
              <p>{message}</p>
            </IonText>
          )}
          {error && (
            <IonText color="danger">
              <p>{error}</p>
            </IonText>
          )}
          {/* Back to Sign In link */}
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Link to="/signin" color="primary">
              ← Back to Sign In
            </Link>
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default ForgotPassword;
